module.exports = __webpack_public_path__ + "static/CareLabel-v3-3aa5fa6d11e1eb2642812efe55c9848a.svg";